import { PermissionEnum } from '@Application/Security/Roles';
import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';

/** Users are named through the account's user list, hence the second permission at the user level. */
const useCanManageLimitLevel = (level: AiCostLimitLevel): boolean => {
	const canWriteLimits = useHasPermission(PermissionEnum.AI_COST_LIMIT_WRITE);
	const canReadUsers = useHasPermission(PermissionEnum.USER_READ_ACCOUNT);

	return canWriteLimits && (level !== 'user' || canReadUsers);
};

export default useCanManageLimitLevel;
